<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <label class="input-group-text" for="inputGroupSelect01">{{
          tx(this.attributes.label)
        }}</label>
        <helpWidget
          v-if="this.attributes.help_img || this.attributes.help"
          class="md-layout-item"
          :help="help_key"
          :help_img="`${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`"
          :help_style="this.attributes.help_style"
        ></helpWidget>
      </div>
      <md-field>
        <md-select
          v-model="selected"
          class="custom-select"
          id="inputGroupSelect01"
        >
          <md-option disabled value="">Please select one</md-option>
          <md-option :value="o" v-for="o in options" :key="o">{{
            tx(`${model}_${o}`)
          }}</md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "select-input-component",
  mixins: [componentMixin, inputComponentMixin],
  data() {
    return {
      selected: null,
      EventProgress: "0",
    };
  },
  async mounted() {
    this.selected = this.attributes.default;
    this.update_selected();

    Bus.$on("selected-changed", () => {
      this.update_selected();
    });
  },
  created() {},
  watch: {
    selected: function (value) {
      this.$store.commit("setSelected", {
        param: this.model,
        value,
        mode: "slider",
      });
      this.update_selected();
    },
  },
  computed: {
    options() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
  },
};
</script>
<style scoped>
/* ce style est calé sur le style de 'container-fluid' dans lequel est intégré un collapsibleWidget*/
.input-group {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
